// extracted by mini-css-extract-plugin
module.exports = {"root":"NewAssetButtonWrapper_root__vl3QU"};